import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '@senderra/shared/baseQuery/basePharmaNavigatorQuery';
import { GetPreferencesPayload, GetPreferencesResponse } from './types';
import { Doctor } from '@senderra/shared/features/doctors/api/types';

const BASE_URL = '/api/v1/me/preferences';

export const preferencesApi = createApi({
    reducerPath: 'preferencesApi',
    baseQuery,
    tagTypes: ['preferences'],
    endpoints: (builder) => ({
        getPreferences: builder.query<GetPreferencesResponse, GetPreferencesPayload>({
            query: (preferences) => ({
                url: BASE_URL,
                method: 'POST',
                body: preferences,
            }),
            providesTags: ['preferences'],
        }),
        assignPreferences: builder.mutation<Array<Doctor>, Array<Doctor>>({
            query: (preferences) => ({
                url: `${BASE_URL}/assign`,
                method: 'POST',
                body: preferences,
            }),
            invalidatesTags: ['preferences'],
        }),
        deletePreference: builder.mutation<void, Array<string>>({
            query: (preferences) => ({
                url: `${BASE_URL}/remove`,
                method: 'DELETE',
                body: preferences,
            }),
            invalidatesTags: ['preferences'],
        }),
        deleteAllPreferences: builder.mutation<void, void>({
            query: () => ({
                url: `${BASE_URL}/remove-all`,
                method: 'DELETE',
            }),
            invalidatesTags: ['preferences'],
        }),
    }),
});

export const {
    useGetPreferencesQuery,
    useAssignPreferencesMutation,
    useDeletePreferenceMutation,
    useDeleteAllPreferencesMutation,
} = preferencesApi;
